import { defineComponent as h, ref as l, computed as s, resolveComponent as u, openBlock as i, createElementBlock as g, normalizeClass as m, createBlock as v, mergeProps as O, createCommentVNode as c, createElementVNode as b, renderSlot as B, Fragment as $, createVNode as S, withModifiers as M } from "vue";
import { useIntersectionObserver as T } from "@vueuse/core";
import { O as w } from "./OrIconButton-BlHCLpeW.mjs";
import { O as C, I as k } from "./OrIcon-k8cyvh-D.mjs";
import { O as V } from "./OrTooltip-DqwjoE82.mjs";
import { _ as P } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const N = [
  // Group
  "group",
  // Layout
  "layout-row",
  // Spacing
  "px-lg md:px-sm",
  "py-sm+ md:py-sm",
  "gap-sm md:gap-sm",
  // Interactivity
  "interactivity-click",
  // Typography
  "typography-body-2-regular md:typography-caption-regular",
  // Typography (selected)
  "selected:typography-body-2-semibold selected:md:typography-caption-semibold",
  // Theme
  "theme-preset-3-primary",
  "dark:theme-preset-3-primary-dark",
  "theme-foreground-outline",
  "dark:theme-foreground-outline-dark",
  // Theme (selected)
  "selected:theme-foreground-default",
  "dark:selected:theme-foreground-default-dark",
  "selected:bg-primary-opacity-0-08",
  "dark:selected:bg-primary-opacity-0-08-dark",
  // Theme (hover)
  "hover:md:theme-foreground-default",
  "dark:hover:md:theme-foreground-default-dark",
  // Theme (active)
  "active:theme-foreground-default",
  "dark:active:theme-foreground-default-dark"
], E = [
  // Iconography (hover)
  "group-hover:iconography-filled"
], F = [
  // Iconography (selected)
  "selected:iconography-filled"
], W = h({
  name: "OrMenuItem",
  components: {
    OrIcon: C,
    OrIconButton: w,
    OrTooltip: V
  },
  props: {
    icon: {
      type: [String, Object],
      default: void 0
    },
    closeButton: {
      type: Boolean,
      default: !1
    },
    selected: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    tooltipText: {
      type: String,
      default: ""
    }
  },
  emits: [
    "click",
    "focus",
    "blur",
    "close"
  ],
  expose: [
    "root"
  ],
  setup(e) {
    const o = l(), r = l(), f = l(), n = l(!1), { stop: y } = T(o, ([{ isIntersecting: I }]) => {
      n.value = I;
    }), d = s(() => [
      "or-menu-item-v3",
      ...N
    ]), a = s(() => [
      ...E,
      ...e.selected ? F : []
    ]), p = s(() => typeof e.icon == "string" ? {
      icon: e.icon,
      variant: k.Inherit
    } : {
      variant: k.Inherit,
      ...e.icon
    }), t = s(() => n.value ? r.value !== void 0 && r.value.clientWidth < r.value.scrollWidth : !1);
    return {
      content: r,
      root: o,
      tooltip: f,
      rootStyles: d,
      iconStyles: a,
      isTooltipShown: t,
      iconProps: p,
      isRootVisible: n,
      stop: y
    };
  }
}), j = ["tabindex", "selected", "disabled"], z = /* @__PURE__ */ b("div", {
  class: /* @__PURE__ */ m(["grow"])
}, null, -1);
function R(e, o, r, f, n, y) {
  const d = u("OrIcon"), a = u("OrIconButton"), p = u("OrTooltip");
  return i(), g("div", {
    ref: "root",
    class: m(e.rootStyles),
    tabindex: e.disabled ? void 0 : 0,
    selected: e.selected,
    disabled: e.disabled,
    onClick: o[3] || (o[3] = (t) => e.$emit("click", t)),
    onFocus: o[4] || (o[4] = (t) => e.$emit("focus", t)),
    onBlur: o[5] || (o[5] = (t) => e.$emit("blur", t))
  }, [
    e.icon && e.iconProps.icon ? (i(), v(d, O({
      key: 0,
      class: e.iconStyles
    }, e.iconProps), null, 16, ["class"])) : c("", !0),
    b("div", {
      ref: "content",
      class: m(["truncate", "w-full"]),
      onMouseover: o[0] || (o[0] = (t) => e.tooltip && e.tooltip.open()),
      onMouseout: o[1] || (o[1] = (t) => e.tooltip && e.tooltip.close())
    }, [
      B(e.$slots, "default")
    ], 544),
    e.closeButton ? (i(), g($, { key: 1 }, [
      z,
      S(a, {
        icon: "close",
        disabled: e.disabled,
        onClick: o[2] || (o[2] = M((t) => e.$emit("close"), ["stop"]))
      }, null, 8, ["disabled"])
    ], 64)) : c("", !0),
    e.isTooltipShown ? (i(), v(p, {
      key: 2,
      ref: "tooltip",
      content: e.tooltipText,
      trigger: e.root
    }, null, 8, ["content", "trigger"])) : c("", !0)
  ], 42, j);
}
const K = /* @__PURE__ */ P(W, [["render", R]]);
export {
  K as O
};
//# sourceMappingURL=OrMenuItem-BHRMA0L1.mjs.map
